import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage, injectIntl } from 'react-intl';

import * as UserActions from '../actions/user';
import InviteCodeForm from './forms/InviteCodeForm';
import { navigateToCreationPage } from '../utils/utils';

/**
 * Shown to a Keycloak-authenticated user who has no member yet (GET /v2/members/me
 * returned 404) and whose company could not be resolved automatically (no
 * superCompanyId). Mirrors the mobile fallback: the user resolves their company
 * either by picking a country flag or by entering an invitation code, then continues
 * into the registration flow (navigateToCreationPage → Creation).
 */
class SsoRegisterCompany extends Component {
  constructor(props) {
    super(props);
    this.handleInviteSubmit = this.handleInviteSubmit.bind(this);
  }

  handleInviteSubmit(data) {
    this.props.checkInviteCode(data.inviteCode).then((resp) => {
      if (resp.type === 'user/CHECK_INVITE_CODE_SUCCESS') {
        navigateToCreationPage(resp.payload.data.id);
      }
    });
  }

  renderFlags() {
    const { mapCountries, intl } = this.props;

    return Object.keys(mapCountries).reduce((acc, iso) => {
      const { companyId, iconUrl } = mapCountries[iso] || {};

      if (companyId) {
        acc.push(
          <li key={iso} onClick={() => navigateToCreationPage(companyId)}>
            <i style={{ backgroundImage: `url(${iconUrl})` }} />
            <span>{intl.formatMessage({ id: 'iso__' + iso })}</span>
          </li>
        );
      }

      return acc;
    }, []);
  }

  render() {
    const flags = this.renderFlags();

    return (
      <div className="sso-register-company">
        <div className="src-inner">
          <div className="src-title text-center f-25 mt-40 mb-10">
            <FormattedMessage id="only.sso.select.company.select.title" />
          </div>

          {flags.length > 0 && (
            <div className="text-center mb-35">
              <ul className="flag-country-selector">{flags}</ul>
            </div>
          )}

          <InviteCodeForm
            onSubmit={this.handleInviteSubmit}
            onRetry={this.props.removeInviteError}
            isInPopup={false}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    mapCountries: state.brand?.branded?.mapCountries || {}
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...UserActions }, dispatch);
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(SsoRegisterCompany));
